
import { ArcadeCabinetsAppState } from 'arcade/sections/cabinets/interfaces';
import get from 'lodash/get';

export const getArcadeArcadeCabinets = (state: ArcadeCabinetsAppState) =>
    get(state, 'arcade.cabinets', {});

export const getArcadeCabinetList = (state: ArcadeCabinetsAppState) =>
    get(getArcadeArcadeCabinets(state), 'list', []);

export const hasArcadeCabinets = (state: ArcadeCabinetsAppState) =>
    !!getArcadeCabinetList(state).length;



export const getArcadeCabinetsCabinet = (state: ArcadeCabinetsAppState) =>
    get(getArcadeArcadeCabinets(state), 'cabinet', {});

export const getArcadeCabinetId = (state: ArcadeCabinetsAppState) =>
    get(getArcadeCabinetsCabinet(state), 'cabinetId', null);

export const hasArcadeCabinetId = (state: ArcadeCabinetsAppState) =>
    !!getArcadeCabinetId(state);

export const hasArcadeCabinetRomId = (state: ArcadeCabinetsAppState) =>
    !!get(getArcadeCabinetsCabinet(state), 'romId', null);



export const getRomOptions = (state: ArcadeCabinetsAppState) =>
    get(getArcadeArcadeCabinets(state), 'options', []);

